import { useMutation } from "@tanstack/react-query";
import boardPermissionRequestService from "../api/boardPermissionRequestService";

export const useApproveRequest = () => {
  const { approveRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["approve-request"],
    mutationFn: async ({ id }) => {
      const response = await approveRequest(id);
      return response.data;
    },
  });
};

export const useDenyRequest = () => {
  const { denyRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["deny-request"],
    mutationFn: async ({ id }) => {
      const response = await denyRequest(id);
      return response.data;
    },
  });
};

export const useApproveManyRequest = () => {
  const { approveManyRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["approve-many-request"],
    mutationFn: async ({ requestIds }) => {
      const response = await approveManyRequest(requestIds);
      return response.data;
    },
  });
};

export const useDenyManyRequest = () => {
  const { denyManyRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["deny-many-request"],
    mutationFn: async ({ requestIds }) => {
      const response = await denyManyRequest(requestIds);
      return response.data;
    },
  });
};

export const useApproveAllRequest = () => {
  const { approveAllRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["approve-all-request"],
    mutationFn: async () => {
      const response = await approveAllRequest();
      return response.data;
    },
  });
};

export const useDenyAllRequest = () => {
  const { denyAllRequest } = boardPermissionRequestService();

  return useMutation({
    mutationKey: ["deny-all-request"],
    mutationFn: async () => {
      const response = await denyAllRequest();
      return response.data;
    },
  });
};

